import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Repo } from '@repos/repo.service';
import { MatterHistory } from '@models/businesses';
import { CollectionPaths } from '@models/collections';

export interface SaleHistoryCollectionParams {
	businessId: string;
	matterId: string;
}

@Injectable({
	providedIn: 'root',
})
export class HistoryService extends Repo<
	MatterHistory,
	SaleHistoryCollectionParams
> {
	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}

	GetCollectionPath(pathParams: SaleHistoryCollectionParams): string {
		return CollectionPaths.business_matter_history(
			pathParams.businessId,
			pathParams.matterId,
		);
	}
}
